import React from 'react';
import ReactModal from 'react-modal';

const DeviceModalSettingReason = ({ isOpen, onRequestClose, onSave, reason, handleReasonChange, backgroundColorModal, textColor, inputStyles }) => {
    if (!isOpen) {
        return null;  // Do not render the modal if it's not open
    }

    return (
        <ReactModal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            contentLabel="Reason for Modification"
            style={{
                overlay: {
                    backgroundColor: 'rgba(50, 50, 50, 0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                },
                content: {
                    maxWidth: '400px',
                    maxHeight: '300px',
                    margin: 'auto',
                    padding: '20px',
                    borderRadius: '10px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    backgroundColor: backgroundColorModal,
                    color: textColor,
                }
            }}
        >
            <h4>Please provide a reason for the modification</h4>
            <textarea
                value={reason}
                onChange={handleReasonChange}
                placeholder="Enter reason here"
                style={{
                    ...inputStyles,
                    margin: '20px 0',
                    width: '100%',
                    height: '100px',
                    resize: 'vertical'
                }}
            />
            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <button className="btn btn-outline-secondary" onClick={onRequestClose}>
                    Cancel
                </button>
                <button
                    className="btn btn-outline-primary"
                    onClick={() => {
                        onSave();
                        onRequestClose();
                    }}
                    disabled={!reason.trim()}  // Disable save button if reason is empty
                >
                    Save
                </button>
            </div>
        </ReactModal>
    );
};

export default DeviceModalSettingReason;
